import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {ApiService} from "../../services/api.service";
import {Image} from "../../models/image";
import {ActivatedRoute} from "@angular/router";
import {NgxMasonryComponent, NgxMasonryOptions} from 'ngx-masonry';

@Component({
  selector: 'app-image-page',
  templateUrl: './image-page.component.html',
  styleUrls: ['./image-page.component.css']
})
export class ImagePageComponent implements OnInit {
  public images: Image[]=[];
  public focusImage: number=-1;
  public loadedImages=0;
  public updateMasonryLayout:boolean=false;
  private screenWidth: number;
  private screenHeight: number;

  public myOptions: NgxMasonryOptions = {
    gutter: 10
  };

  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;


  constructor(public apiService:ApiService) { }

  public layout(){
    this.masonry.reloadItems();
    this.masonry.layout();
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    this.apiService.getImages().subscribe(images=>{
      this.loadedImages=0;
      this.images=images;
      this.updateMasonryLayout=true;
    });
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    //In chrome and some browser scroll is given to body tag
    let pos = (document.documentElement.scrollTop || document.body.scrollTop); + document.documentElement.offsetHeight;
    let max = document.documentElement.scrollHeight;
    // pos/max will give you the distance between scroll bottom and and bottom of screen in percentage.
    let percent=(pos/max)*100;
    //console.log("Pos: "+pos+" Max: "+max+' div '+percent+" loadedImages"+this.loadedImages+" / "+this.images.length);
    if(percent>75)   {
      if(!this.apiService.isLoading && this.apiService.hasMore && this.loadedImages==this.images.length){
        this.apiService.loadMore();
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  imagesLoaded(image: Image) {
    this.loadedImages++;
    //console.log(this.loadedImages+"/"+this.images.length);
    if(this.loadedImages==3 && this.images.length>3){
      this.layout(); //run layout after 3 images
    }
    if(this.loadedImages/this.images.length==0.2){
      this.layout(); //run layout at 50%
    }

    if(this.loadedImages==this.images.length){
      console.log("all images loaded - restarting layout", this.loadedImages);
      //this.updateMasonryLayout=true;
      this.layout();
    }
  }

  navNext(event){
    this.focusImage=(this.focusImage+1)%this.images.length
    event.stopPropagation();
  }

  navBack(event) {
    if(this.focusImage>0){
      this.focusImage--;
    }else{
      this.focusImage=this.images.length-1;
    }
    event.stopPropagation();
  }
}
